/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { LogsSchemaColumn } from '../models/LogsSchemaColumn';

/**
* Schema information for a log source.
*/
export class LogsSchema {
  /**
  * The application name.
  */
  'appName'?: string;
  /**
  * The path to the log source.
  */
  'path'?: string;
  /**
  * The name of the schema.
  */
  'schemaName'?: string;
  /**
  * The number of rows in the log source.
  */
  'rowCount'?: number;
  /**
  * The columns in the schema.
  */
  'columns'?: Array<LogsSchemaColumn>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "appName",
      "baseName": "appName",
      "type": "string",
      "format": ""
    },
    {
      "name": "path",
      "baseName": "path",
      "type": "string",
      "format": ""
    },
    {
      "name": "schemaName",
      "baseName": "schemaName",
      "type": "string",
      "format": ""
    },
    {
      "name": "rowCount",
      "baseName": "rowCount",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "columns",
      "baseName": "columns",
      "type": "Array<LogsSchemaColumn>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return LogsSchema.attributeTypeMap;
  }

  public constructor() {
  }
}

